<template>
  <div class="product">
    <header-nav :linkId="activeNum"></header-nav>
    <div class="main">
      <el-tabs v-model="activeName" @tab-click="handleClick" class="tabs">
        <el-tab-pane label="支付开票" name="1">
          <Pay></Pay>
        </el-tab-pane>
        <el-tab-pane label="扫码开票" name="2">
          <ScanCode></ScanCode>
        </el-tab-pane>
        <el-tab-pane label="商家主动开票" name="3">
          <Initiative></Initiative>
        </el-tab-pane>
      </el-tabs>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import headerNav from '../components/Header.vue'
import Pay from '../components/Pay.vue'
import ScanCode from '../components/ScanCode.vue'
import Initiative from '../components/Initiative.vue'
import Footer from '../components/Footer.vue'
export default {
  name: 'Home',
  components: {
    headerNav,
    Pay,
    ScanCode,
    Initiative,
    Footer
  },
  data() {
    return {
      activeNum: '2',
      activeName: localStorage.getItem('billingType') || '1'
    }
  },
  methods: {
    handleClick(tab, event) {
      localStorage.removeItem('billingType')
    }
  }
}
</script>

<style lang="less" scoped>
.product {
  /deep/ .el-tabs__nav-wrap::after {
    background: transparent;
  }
  .tabs {
    text-align: center;
    margin-top: .6rem;
    /deep/ .el-tabs__item {
      font-size: .16rem;
    }
    /deep/ .el-tabs__nav-wrap {
      display: flex;
      justify-content: center;
    }
    /deep/ .el-tabs__item:not(:last-child) {
      border-right: 1px solid #d7d7d7;
      height: .16rem;
      line-height: 16px;
    }
    /deep/ .el-tabs__item.is-active,
    /deep/ .el-tabs__item:hover {
      color: #B71C22;
    }
    /deep/ .el-tabs__active-bar {
      background: #B71C22;
      height: .04rem;
    }
  }
}
@media (max-width: 768px) {
  .product {
    .tabs {
      /deep/ .el-tabs__item {
        font-size: .3rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/ProductDesc.vue